import { send } from 'server';
import { workerService } from 'js/services/worker.service';

export const getJackpots = ({
    jackpotsCasinoUrl, jackpotsCasino, currencyCode
}) => workerService.request('jackpot', {
    url: `${jackpotsCasinoUrl}?casino=${jackpotsCasino}&currency=${currencyCode}&includeCasinoTotal=true`,
    currencyCode
});

export const getBingoJackpots = ({ bingoRegion, casinoName }) =>
    send({
        ID: 81704,
        description: 'Get Bingo Jackpots',
        responses: [81705, 81706],
        casino: casinoName,
        region: bingoRegion,
        uniqueJackpots: true,
        version: '1.7'
    });
